// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Simulator_actions-container{position:fixed;bottom:0;right:0;width:100%;display:flex;padding:10px 20px;justify-content:space-between;box-shadow:0 0 20px rgba(12,35,44,.1)}@media(max-width:768px){.Simulator_actions-container{background:#fff}}@media(min-width:769px){.Simulator_actions-container{position:relative;box-shadow:none}}.Simulator_actions-container .btn-primary_chevron{margin-left:auto}", ""]);
// Exports
module.exports = exports;
